<div class="business-dialog-container">
    <div class="dialog-header">
        <h3 class="dialog-title">Business Details Required</h3>
        <button mat-icon-button class="close-btn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="form-body">
        <p class="intro-text">To confirm your booking as a business, please provide the following details. This will
            update your profile.</p>

        <form #businessForm="ngForm" (ngSubmit)="submitForm(businessForm, $event)" class="form">

            <div class="form-row">
                <!-- Your Name -->
                <div class="custom-input-box half-width mb-12">
                    <input type="text" [(ngModel)]="businessData.firstname" name="firstname" placeholder="Your Name"
                        required />
                </div>

                <!-- Company Name -->
                <div class="custom-input-box half-width mb-12">
                    <input type="text" [(ngModel)]="businessData.accountdetails.companyname" name="companyname"
                        placeholder="Company Legal Name" required />
                </div>
            </div>

            <!-- Company Address -->
            <div class="custom-input-box full-width mb-12">
                <textarea [(ngModel)]="businessData.accountdetails.companyAddress" name="companyAddress" rows="1"
                    placeholder="Company Address" required></textarea>
            </div>

            <!-- Company Logo Upload (Matching Profile Style) -->
            <div class="company-logo-wrapper">
                <div class="logo-preview" [style.backgroundImage]="getLogoStyle()">
                </div>
                <input type="file" id="logoInput" (change)="onLogoSelected($event)" accept="image/*" hidden />
                <div class="logo-info">
                    <p>Upload a clear PNG or JPG logo.</p>
                    <div class="logo-actions" style="display: flex; gap: 10px; margin-top: 8px">
                        <button mat-stroked-button type="button" color="primary" (click)="triggerFileInput()" class="logo-btn">
                            <mat-icon>{{ businessData.accountdetails.companyLogoUrl ? 'edit' : 'upload' }}</mat-icon>
                            {{ businessData.accountdetails.companyLogoUrl ? 'Edit Logo' : 'Upload Logo' }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="phone-row mb-12">
                <!-- Business Phone -->
                <div class="phone-group">
                    <div class="custom-input-box country-select">
                        <mat-select [(ngModel)]="businessData.accountdetails.countryCode" name="countryCode"
                            panelClass="wide-country-dropdown" disableOptionCentering>
                            <mat-select-trigger>
                                <div class="flex-center" *ngIf="getSelectedCountry() as sel">
                                    <img [src]="sel.flag" class="flag-icon-small" />
                                    {{ sel.code }}
                                </div>
                            </mat-select-trigger>
                            <mat-option *ngFor="let c of countryList" [value]="c.code">
                                <img [src]="c.flag" class="flag-icon" />
                                {{ c.name }} ({{ c.code }})
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="custom-input-box phone-input flex-1">
                        <input type="text" [(ngModel)]="businessData.accountdetails.phoneNumber" name="phoneNumber"
                            [maxlength]="currentPhoneLimit" (keypress)="numberOnly($event)"
                            placeholder="Business Phone" required />
                    </div>
                </div>

                <!-- Telephone -->
                <div class="phone-group">
                    <div class="custom-input-box country-select">
                        <mat-select [(ngModel)]="businessData.accountdetails.telephoneCountryCode"
                            name="telephoneCountryCode" panelClass="wide-country-dropdown" disableOptionCentering>
                            <mat-select-trigger>
                                <div class="flex-center" *ngIf="getTelSelectedCountry() as sel">
                                    <img [src]="sel.flag" class="flag-icon-small" />
                                    {{ sel.code }}
                                </div>
                            </mat-select-trigger>
                            <mat-option *ngFor="let c of countryList" [value]="c.code">
                                <img [src]="c.flag" class="flag-icon" />
                                {{ c.name }} ({{ c.code }})
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="custom-input-box phone-input flex-1">
                        <input type="text" [(ngModel)]="businessData.accountdetails.telephone" name="telephone"
                            [maxlength]="currentTelLimit" (keypress)="numberOnly($event)" placeholder="Telephone" />
                    </div>
                </div>
            </div>

            <div class="form-row">
                <!-- Shared Email -->
                <div class="half-width mb-12">
                    <div class="custom-input-box">
                        <input type="email" [(ngModel)]="businessData.accountdetails.emailid" name="emailid" required
                            email pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,4}$"
                            placeholder="Business Email" />
                    </div>
                </div>

                <!-- Trade License No -->
                <div class="custom-input-box half-width mb-12">
                    <input type="text" [(ngModel)]="businessData.accountdetails.tradeLicenseNo" name="tradeLicenseNo"
                        placeholder="Trade License No." required />
                </div>
            </div>

            <div class="form-row" style="margin-bottom: 4px;">
                <!-- License Expiry Date -->
                    <div style="position: relative; width: 100%; flex: 1" class="mb-12">
                        <div class="custom-input-box" style="cursor: text">
                            <input type="text" [(ngModel)]="expiryDisplay" name="expiryDate"
                                (input)="onExpiryInput($event)" (focus)="showExpiryCalendar = true"
                                (click)="$event.stopPropagation()"
                                placeholder="License Expiry Date (DD/MM/YYYY)" required />
                            <mat-icon class="suffix-icon" (click)="openExpiryCalendar($event)" style="cursor: pointer">calendar_today</mat-icon>
                        </div>

                        <!-- Inline Calendar -->
                        <div class="calendar-dropdown" *ngIf="showExpiryCalendar" (click)="$event.stopPropagation()">
                            <div class="calendar-header">
                                <span class="chevron" (click)="prevMonth(); $event.stopPropagation()">&#8249;</span>
                                <div class="header-selectors">
                                    <select [ngModel]="currentMonth" (ngModelChange)="selectMonth($event)" name="calMonth">
                                        <option *ngFor="let m of monthNames; let i = index" [value]="i">{{ m }}</option>
                                    </select>
                                    <select [ngModel]="currentYear" (ngModelChange)="selectYear($event)" name="calYear">
                                        <option *ngFor="let y of years" [value]="y">{{ y }}</option>
                                    </select>
                                </div>
                                <span class="chevron" (click)="nextMonth(); $event.stopPropagation()">&#8250;</span>
                            </div>
                        <div class="calendar-weekdays">
                            <span *ngFor="let d of weekdays">{{ d }}</span>
                        </div>
                        <div class="calendar-grid">
                            <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                                [class.is-today]="day.isToday" [class.is-past]="day.isPast"
                                [class.selected]="day.isSelected"
                                (click)="selectExpiryDay(day); $event.stopPropagation()">{{ day.date }}</span>
                        </div>
                    </div>
                </div>

                <!-- Issued By -->
                <div class="custom-input-box half-width mb-12">
                    <input type="text" [(ngModel)]="businessData.accountdetails.issuedBy" name="issuedBy"
                        placeholder="License Issued By" required />
                </div>
            </div>

            <!-- Trade License Upload -->
            <div class="upload-wrapper">
                <input type="file" id="licenseFileBusiness" (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png,.webp"
                    class="file-input" />
                <label for="licenseFileBusiness" class="upload-btn">
                    {{ businessData.accountdetails.companyDocuments?.length ? 'Trade License Selected' : 'Upload Trade License Copy' }}
                    <small>PDF, JPG, JPEG, PNG, WEBP up to 10MB</small>
                </label>

                    <!-- Document Previews -->
                    <div class="preview-mini-card-container" *ngIf="businessData.accountdetails.companyDocuments?.length">
                        <div class="template-mini-card" *ngFor="let doc of businessData.accountdetails.companyDocuments; let i = index">
                            <div class="mini-content" [class.uploading]="doc.uploading">
                                <!-- Explicit Close Button -->
                                <button mat-icon-button type="button" class="remove-btn-absolute" (click)="removeDocumentByIndex(i)" matTooltip="Remove">
                                    <mat-icon>close</mat-icon>
                                </button>

                                <mat-progress-spinner *ngIf="doc.uploading" mode="indeterminate" diameter="30" class="upload-spinner"></mat-progress-spinner>

                                <!-- Image Preview -->
                                <img *ngIf="isImage(doc.name) && !doc.uploading" [src]="doc.url" alt="Preview" class="preview-img" />

                                <!-- PDF Preview -->
                                <div *ngIf="!isImage(doc.name) && !isDoc(doc.name) && !doc.uploading" class="pdf-preview">
                                    <mat-icon>picture_as_pdf</mat-icon>
                                    <span>PDF Document</span>
                                </div>

                                <!-- DOC Preview -->
                                <div *ngIf="isDoc(doc.name) && !doc.uploading" class="pdf-preview">
                                    <mat-icon>description</mat-icon>
                                    <span>Document</span>
                                </div>

                                <!-- Action Buttons (Hover) -->
                                <div class="card-actions" *ngIf="!doc.uploading">
                                    <button type="button" mat-icon-button class="action-btn view-btn" matTooltip="View" (click)="viewDocument(i)" *ngIf="isImage(doc.name)">
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                    <a [href]="doc.url" target="_blank" mat-icon-button class="action-btn view-btn" matTooltip="View" *ngIf="!isImage(doc.name)">
                                        <mat-icon>visibility</mat-icon>
                                    </a>
                                </div>
                            </div>
                            <div class="template-name">{{ doc.name }}</div>
                        </div>

                        <!-- Add More Button -->
                        <div class="add-more-wrapper">
                            <input type="file" id="addMoreFilesDialog" (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png,.webp" class="file-input" />
                            <label for="addMoreFilesDialog" class="add-more-btn" matTooltip="Add more documents">
                                <mat-icon>add_circle</mat-icon>
                                <span>Add more</span>
                            </label>
                        </div>
                    </div>
            </div>

            <button class="primary-cta" type="submit" [disabled]="isSubmitting">
                Save and Continue
            </button>

            <p class="footer-text">All fields are mandatory.</p>
        </form>
    </div>
</div>